import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { fetchSingleMatStock } from '../../../Store/PHPSlice/MatStock';
import { Grid, Paper } from '@mui/material';
import { BallotOutlined } from '@mui/icons-material';

const MatStockView = () => {
  const { Id } = useParams();
  const [purData, setPurData] = useState([]);
  const pidata = useSelector((state) => state.MatStockData.singleMatStock);
  const dispatch = useDispatch();
  useEffect(() => {
    if (Id) {
      dispatch(fetchSingleMatStock(Id));
    }
  }, [dispatch, Id]);

  const handleViewClick = (form) => {
    // Construct the URL with query parameters or use a placeholder route
    const url = `/BaleLumpView?form=${encodeURIComponent(JSON.stringify(form))}`;

    // Open the URL in a new tab
    window.open(url, '_blank', 'width=900,height=600,scrollbars=yes,resizable=yes');
  };
  console.log("item=>", pidata);
  return (
    <>
      <Grid item xs={12}>
        <Paper style={{ padding: '3vh', margin: '0' }}>
          <div style={{ margin: '1% 0%', width: '100%' }}>

            <h3 className='centered-heading'>Material Stock Info</h3>
            <div className="dashed-line"></div>

            {pidata?.data?.length > 0 ? (
              pidata.data.map((val, valIndex) => (
                <div key={valIndex}>
                  <table style={{ margin: '1% 5%', fontSize: '15px' }}>
                    <tbody>
                      <tr>
                        <td style={{ width: '200px' }}>
                          <b>Date</b>:
                        </td>
                        <td
                          style={{
                            width: '30vw',
                            padding: '0.2% 1.5%',
                            fontSize: '15px',
                            fontWeight: 'bold',
                            color: '#333',
                          }}
                          className='light-color'
                        >
                          {new Date().toLocaleDateString('en-IN')}
                        </td>
                      </tr>
                      <tr>
                        <td><b>Location:</b></td>
                        <td className='light-color'>{val.locNm}</td>
                      </tr>
                      <tr>
                        <td><b>Material Name:</b></td>
                        <td className='light-color'>{val.materialNm}</td>
                      </tr>

                      <tr>
                        <td><b>Size:</b></td>
                        <td className='light-color'>{val.size}</td>
                      </tr>
                      <tr>
                        <td><b>Description:</b></td>
                        <td className='light-color'>{val.description}</td>
                      </tr>

                      <tr>
                        <td><b>Total Stock Qty:</b></td>
                        <td className='light-color' style={{ color: 'green' }}><b>{val.stkqty}</b></td>
                      </tr>

                      <tr>
                        <td><b>Given Qty:</b></td>
                        <td className='light-color' style={{ color: 'blue' }}><b>{val.givenqty}</b></td>
                      </tr>

                      <tr>
                        <td><b>Total Balance Qty:</b></td>
                        <td className='light-color' style={{ color: 'red' }}><b>{val.balqty}</b></td>
                      </tr>
                    </tbody>
                  </table>

                  {/* === Stock Inward Table === */}
                  <h4 style={{ marginLeft: '5%', marginTop: '2%', color: 'green' }}>Stock Inward Details</h4>
                  <table className='table table-bordered' style={{ width: '90%', margin: '0 5%' }}>
                    <thead style={{ background: '#d4edda' }}>
                      <tr>
                        <th>Sr.No.</th>
                        <th>Date</th>
                        <th>Inward No</th>
                        <th>Per Packet Qty</th>
                        <th>Packet Qty</th>
                        <th>Inward Qty</th>
                      </tr>
                    </thead>
                    <tbody>
                      {val.inward && val.inward.length > 0 ? (
                        val.inward.map((item, i) => (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            <td>{item.dt}</td>
                            <td>{item.inwardNo}</td>
                            <td>{item.pkt}</td>
                            <td>{item.pktqty}</td>
                            <td>{item.qty}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={6} style={{ textAlign: 'center', color: '#888' }}>
                            No inward records found
                          </td>
                        </tr>
                      )}
                    </tbody>
                    {/* === ✅ FOOTER for Total Inward === */}
                    {val.inward && val.inward.length > 0 && (
                      <tfoot style={{ background: '#fff', fontWeight: 'bold' }}>
                        <tr>
                          <td colSpan={4} style={{ textAlign: 'right' }}><b>Total </b></td>
                          <td>
                            <b>        {val.inward.reduce((sum, item) => sum + parseFloat(item.pktqty || 0), 0)}
                            </b>
                          </td>
                          <td>
                            <b>        {val.inward.reduce((sum, item) => sum + parseFloat(item.qty || 0), 0)}
                            </b>
                          </td>
                        </tr>
                      </tfoot>
                    )}
                  </table>

                  {/* === Stock Outward Table === */}
                  <h4 style={{ marginLeft: '5%', marginTop: '2%', color: 'red' }}>Stock Outward Details</h4>
                  <table className='table table-bordered' style={{ width: '90%', margin: '0 5%' }}>
                    <thead style={{ background: '#f8d7da' }}>
                      <tr>
                        <th>Sr.No.</th>
                        <th>Date</th>
                        <th>Outward No</th>
                        <th>Employee Name</th>
                        <th>Outward Qty</th>
                      </tr>
                    </thead>
                    <tbody>
                      {val.outward && val.outward.length > 0 ? (
                        val.outward.map((item, i) => (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            <td>{item.dt}</td>
                            <td>{item.outwardNo}</td>
                            <td>{item.empNm}</td>
                            <td>{item.qty}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={5} style={{ textAlign: 'center', color: '#888' }}>
                            No outward records found
                          </td>
                        </tr>
                      )}
                    </tbody>
                    {/* === ✅ FOOTER for Total Outward === */}
                    {val.outward && val.outward.length > 0 && (
                      <tfoot style={{ background: '#ffff', fontWeight: 'bold' }}>
                        <tr>
                          <td colSpan={4} style={{ textAlign: 'right' }}><b>Total Outward Qty</b></td>
                          <td>
                            <b>
                              {val.outward.reduce((sum, item) => sum + parseFloat(item.qty || 0), 0)}
                            </b>
                          </td>
                        </tr>
                      </tfoot>
                    )}
                  </table>
                </div> // ✅ Each map element must close properly
              ))
            ) : (
              <p className='text-center mt-3'>No data found or loading...</p>
            )}


          </div>

        </Paper>
      </Grid>
    </>
  );
}

export default MatStockView;
